import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { LocationsList } from "@/features/admin/locations/list";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  locationId: z.string().optional(),
  parentId: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/locations")({
  validateSearch: searchSchema,
  component: LocationsList,
});
